var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      ref: "igcpopup",
      staticClass: "igc--popup"
    },
    [
      _c(
        "div",
        { staticClass: "pop-wrap", style: { background: _vm.mColor(7) } },
        [
          _vm.config.title
            ? _c("div", {
                staticClass: "pop-header",
                style: {
                  color: _vm.mColor(1),
                  background: _vm.mBackground(8, "bottom")
                },
                domProps: { textContent: _vm._s(_vm.config.title) }
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "pop-body",
              style: { padding: _vm.nopadding ? "0px" : "none" }
            },
            [_vm._t("default")],
            2
          ),
          _c(
            "div",
            {
              staticClass: "pop-foot row",
              style: { background: _vm.mBackground(8, "top") }
            },
            [
              _c("div", {
                staticClass: "pop-foot-btn col",
                style: {
                  color: _vm.mColor(1),
                  background: _vm.mBackground(8, "right")
                },
                domProps: {
                  textContent: _vm._s(_vm.config.btn1_text || "取消")
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("cancel")
                  }
                }
              }),
              _c("div", {
                staticClass: "pop-foot-btn col",
                style: { color: _vm.mColor(4) },
                domProps: {
                  textContent: _vm._s(_vm.config.btn2_text || "确认")
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("confirm")
                  }
                }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }